import React from 'react';
import { Container } from './styles';

import { useAuth } from '../../hooks/Auth';
import LeftHeader from '../Left-Header';
import { useHeader } from '../../hooks/Header';
import RightHeader from '../Right-header';

const Header: React.FC = () => {
  const { token } = useAuth();
  const { header } = useHeader();

  return (
    <Container hasToken={!!token}>
      <LeftHeader bgColor={header.leftBg} color="#FFF" title={header.title} />
      <RightHeader
        bgColor={header.rightBg}
        color="#FFF"
        eventName={header.eventName}
        isScout={header.isScout}
        hasLogout={header.hasLogout}
      />
    </Container>
  );
};

export default Header;
